import { render, staticRenderFns } from "./WSIndex.vue?vue&type=template&id=43e8e1f1&"
import script from "./WSIndex.vue?vue&type=script&lang=js&"
export * from "./WSIndex.vue?vue&type=script&lang=js&"
import style0 from "./WSIndex.vue?vue&type=style&index=0&id=43e8e1f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports